export const toFloat = (data: number, decimal: number): string => {
  const newData = !isNaN(data) ? data : 0;
  return newData.toFixed(decimal);
};

export default toFloat;
